var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_ValueAddedServices"),
        width: "1030px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view reminder-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column content-wrapper" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.Anti_terrorismShipping")
                        }
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { width: "405px" },
                            model: {
                              value: _vm.warningConfig.checkOptionsList,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warningConfig,
                                  "checkOptionsList",
                                  $$v
                                )
                              },
                              expression: "warningConfig.checkOptionsList"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "Manifest" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ManifestReceipt"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "VGM" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.VgmReceipt")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "AMS" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.AmsReceipt")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "ACI" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.AciReceipt")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "AFR" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.AfrReceipt")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { display: "block" },
                                attrs: { label: "ENS" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.EnsReceipt")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column content-wrapper" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_SetAlertNotificationObject")
                        )
                      )
                    ]),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "10px" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: _vm.warningConfig.designatedPosition,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warningConfig,
                                      "designatedPosition",
                                      $$v
                                    )
                                  },
                                  expression: "warningConfig.designatedPosition"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_DesignatedPost")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-checkbox-group",
                          {
                            staticStyle: { "margin-left": "10px" },
                            model: {
                              value: _vm.warningConfig.notifierRolesList,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warningConfig,
                                  "notifierRolesList",
                                  $$v
                                )
                              },
                              expression: "warningConfig.notifierRolesList"
                            }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "1" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "2" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "3" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CustomerService"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "4" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "5" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.OverseaCustomerService")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "6" }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.SalesOfGoods")))]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "10" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.AirlinePerson2"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "12" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.FieldOperation"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "7" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.UserDefinedRole1"))
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { label: "8" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.UserDefinedRole2"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "10px" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: {
                                  change: function($event) {
                                    _vm.warningConfig.notifierIdsList = []
                                  }
                                },
                                model: {
                                  value: _vm.warningConfig.designatedPersonnel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warningConfig,
                                      "designatedPersonnel",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "warningConfig.designatedPersonnel"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_DesignatedPersonnel")
                                  )
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              staticStyle: {
                                width: "205px",
                                "margin-top": "10px"
                              },
                              attrs: {
                                "select-type":
                                  _vm.selectTypeNames.basic_data_User,
                                fields: ["chineseName"],
                                disabled: !_vm.warningConfig
                                  .designatedPersonnel,
                                "callback-params": { key: "userList" },
                                "callback-method-type": "value",
                                "tag-value": "userId",
                                "tag-name": "chineseName",
                                "filter-tag-names": ["chineseName"],
                                "method-params": {
                                  pageSize: 1000000,
                                  active: true,
                                  hasRole: true
                                },
                                "default-multiple-value":
                                  _vm.warningConfig.notifierIdsList,
                                multiple: "",
                                filterable: "",
                                "options-width": "230px"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.warningConfig.notifierIdsList = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReminderModes")))]
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.warningConfig.enableMail,
                              callback: function($$v) {
                                _vm.$set(_vm.warningConfig, "enableMail", $$v)
                              },
                              expression: "warningConfig.enableMail"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Viewer.email")))]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.warningConfig.enableWeChat,
                              callback: function($$v) {
                                _vm.$set(_vm.warningConfig, "enableWeChat", $$v)
                              },
                              expression: "warningConfig.enableWeChat"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Wechat")))]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.commitHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _c("el-button", { on: { click: _vm.close } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }